import {CONTENT_TYPE} from "../../../../utils/constants";

export function makeStarterTemplate({
                                        contentId,
                                        type,
                                    }) {

    if (type === CONTENT_TYPE.LESSON) {
        return {
            id: contentId,

            schemaVersion: 1,

            type: "lesson",

            meta: {
                title: "",
                energyCost: 0,
            },

            fragments: [],
        };
    }

    if (type === CONTENT_TYPE.PROJECT) {
        return {
            id: contentId,

            schemaVersion: 1,

            type: "project",

            meta: {
                title: "",
                energyCost: 0,
            },

            steps: [],
        };
    }

    return null;
}